import * as React from "react";
import { Toggletip } from "@grandvisionhq/lib-visuals";
import { useIntl } from "@grandvisionhq/state";
import { formatPrice } from "@grandvisionhq/utils";
const PriceTooltipContainer = ({ appliedDiscounts }) => {
  const { getLabel, locale, currency } = useIntl();
  const filteredDiscounts = appliedDiscounts.filter((discount) => discount.value > 0);
  if (!filteredDiscounts.length) {
    return null;
  }
  const mappedDiscounts = filteredDiscounts.reduce((result, { value, label }, index) => {
    const discount = `-${formatPrice({ locale, value, currency, isCentAmount: true })} (${label})`;
    const separator = index > 0 ? ", " : `${getLabel("cart.lineItem.discountsApplied")}: `;
    return result + separator + discount;
  }, "");
  return /* @__PURE__ */ React.createElement(Toggletip, { message: mappedDiscounts });
};
export {
  PriceTooltipContainer
};
//# sourceMappingURL=PriceTooltipContainer.js.map
